module.exports = __webpack_public_path__ + "img/20180815_151538_160.4ac35683.jpg";